module.exports = __webpack_public_path__ + "static/media/37.93186d06.mp3";